import * as React from 'react'
import { translateCountryName } from "@ui-seeker/utils"
import {Typography} from "@mui/material";

import { RetailerBlock } from "@components"
import {LinkIconBlock} from "@components";


export default function sellerColumn() {
    return {
        name: 'seller', label: 'Seller',
        options: {
            headerAlign: 'left',
            customBodyRowRenderLite: (value, { sellerURL }) =>
            <LinkIconBlock url={sellerURL} variant="body2" sx={{ display: "inline-block" }} linkProps={{ sx: { display: 'flex' } }}>
                <Typography variant='body2' sx={{ mr: 0.3 }}>{value}</Typography>
            </LinkIconBlock>
        }
    }
}